export default __webpack_public_path__ + "static/jenkins-1f04f42c17d5c8439cfb06119bcc5a95.png";